import React from 'react'
import { css } from 'glamor'
import colors from '../../style/colors'
import { fontWeight } from '../../style/sizes'
import { mediaMaxWidth, SMALL_SCREEN_BREAKPOINT } from '../../style/mixins'
import RightArrow from '../rightArrow'

const lineHeight = 64

const CSS = {
  main: css({
    width: '828px',
    maxWidth: '90%',
    margin: '0 auto'
  }),
  product: css({
    minHeight: `${lineHeight + (25 * 2)}px`,
    borderRadius: '4px',
    backgroundColor: colors.white,
    boxShadow: '0 5px 20px 0 rgba(0,0,0,0.17)',
    marginBottom: '30px',
    padding: '25px 40px',
    transition: 'transform .2s',
    ':hover': {
      transform: 'translateY(-2px)'
    }
  }),
  name: css({
    color: colors.darkText,
    fontSize: '18px',
    fontWeight: fontWeight.semiBold,
    lineHeight: `${lineHeight}px`
  }),
  icon: css({
    display: 'inline-block',
    verticalAlign: 'middle',
    width: '60px',
    height: '60px',
    border: `1px solid ${colors.border}`,
    borderRadius: '4px',
    marginRight: '20px'
  }),
  moreButton: css({
    textAlign: 'center',
    ' button': {
      border: 0,
      backgroundColor: colors.transparent,
      color: colors.blue,
      fontSize: '14px',
      fontWeight: fontWeight.semiBold,
      textTransform: 'uppercase'
    }
  }),
  gdprLink: css({
    color: colors.navy,
    fontSize: '14px',
    fontWeight: fontWeight.bold,
    textAlign: 'right',
    float: 'right',
    lineHeight: `${lineHeight}px`,
    ' > svg': {
      transition: 'transform .2s'
    },
    ':hover': {
      ' > svg': {
        transform: 'translateX(5px)'
      }
    },
    [mediaMaxWidth(SMALL_SCREEN_BREAKPOINT)]: {
      display: 'block',
      float: 'none',
      textAlign: 'left',
      margin: 0,
      padding: 0,
      lineHeight: 1,
      marginTop: '30px'
    }
  })
}

const Product = ({ Name, GDPRLink, Image }) => {
  return (
    <div {...CSS.product}>
      {Image && <img alt={Name} src={Image} {...CSS.icon} />}
      <span {...CSS.name}>{Name}</span>
      <a href={GDPRLink} target='_blank' {...CSS.gdprLink}>Read GDPR Statement <RightArrow /></a>
    </div>
  )
}

class ProductList extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      isOpen: false
    }

    this.toggle = this.toggle.bind(this)
  }

  toggle () {
    this.setState({
      isOpen: !this.state.isOpen
    })
  }

  render () {
    const { data } = this.props
    const { isOpen } = this.state
    const apps = data
      .map(row => row.node)
      .filter(app => app.Image)
    const visible = isOpen ? apps : apps.filter(app => app.TopApp)
    return (
      <div {...CSS.main}>
        {visible.map((app, index) => <Product key={index} {...app} />)}
        {!isOpen && (
          <div {...CSS.moreButton}>
            <button onClick={this.toggle}>Show more</button>
          </div>
        )}
      </div>
    )
  }
}

export default ProductList



// WEBPACK FOOTER //
// ./src/components/productList/index.js